import { makeStyles } from '@material-ui/core';

const styles = theme => ({
  pageTitle: {
    fontSize: 24,
    fontFamily: 'Roboto-Bold',
  },
  headerTitle: {
    fontSize: 18,
    fontFamily: 'Roboto-Bold',
  },
  depotCard: {
    border: '1px solid #D9DCDF',
    borderRadius: 16,
    padding: theme.spacing(2),
    fontSize: 16,

    '& img': {
      height: 72
    }
  },
  arrowsButton: {
    cursor: 'pointer',
    padding: '0 8px',
    height: '1rem',
    opacity: 0.5,
    '&:hover': {
      opacity: 1,
    },
  },
  stepInfoContainer: {

  },
  stepInfoTitle: {
    fontSize: 16,
    fontFamily: 'Roboto-Bold',
    marginBottom: 8,
  },
  serviceFeeVatInput: {
    borderBottom: '1px solid #B5BBC2',
    borderRadius: 0,
    fontSize: 16,
    padding: '6px 32px 6px 7px',
  },
  blueInputs: {
    width: 140,
    padding: '6px 1rem',
    textAlign: 'right'
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none'
  },
  loadingIndicator: {
    color: theme.palette.primary.main
  },
  loadingContainer: {
    width: '100%',
    height: 'calc(100vh - 420px)', // 420px for header and footer
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceInputContainer:{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  serviceFeeQuestionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  asterisk: {
    color: theme.palette.primary.main
  },
});

export default styles;

export const useTableStyles = makeStyles(theme => ({
  tableCell: {
    fontFamily: 'Roboto-Regular',
    fontSize: 14,
    color: '#202A38',
    '&:nth-of-type(1)': {
      width: 350,

      [theme.breakpoints.down('md')]: {
        width: 300,
      }
    },

    '&:nth-of-type(n+2)': {
      width: 200
    },

    '&.totals-cell': {
      textAlign: 'right !important',
      fontFamily: 'Roboto-Bold'
    }
  },
}));

export const useEinzeltitelTableStyles = makeStyles(theme => ({
  tableCell: {
    fontFamily: 'Roboto-Regular',
    fontSize: 14,
    color: '#202A38',
    '&:nth-of-type(1)': {
      width: 350,

      [theme.breakpoints.down('md')]: {
        width: 300,
      }
    },

    '&:nth-of-type(n+2)': {
      width: 120
    },

    '&.totals-cell': {
      textAlign: 'right !important',
      fontFamily: 'Roboto-Bold'
    }
  },
}));

export const useStyles = makeStyles(styles);
